import { styled } from "@pigment-css/react";

export const SecondaryButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.fieldSalesTwo.spacing[12],
  height: theme.fieldSalesTwo.spacing[50],
  padding: `0 ${theme.fieldSalesTwo.spacing[20]}`,
  border: `${theme.strokeWidth.thin} solid ${theme.fieldSalesTwo.colors.neutral[200]}`,
  borderRadius: theme.fieldSalesTwo.radius["44"],
  background: "transparent",
  cursor: "pointer",
  appearance: "none",
  WebkitAppearance: "none",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size.base,
  fontWeight: theme.fieldSalesTwo.font.weight["440"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["148"],
  color: theme.fieldSalesTwo.colors.neutral[800],
  whiteSpace: "nowrap",
  transition: "background-color 120ms ease",
  "&:hover": {
    background: theme.fieldSalesTwo.colors.surface.glassMedium,
  },
  "&:focus-visible": {
    outline: `${theme.strokeWidth.regular} solid ${theme.fieldSalesTwo.colors.neutral[700]}`,
    outlineOffset: `-${theme.strokeWidth.regular}`,
  },
  "&:disabled": {
    opacity: 0.5,
    pointerEvents: "none",
  },
}));
